import React from 'react';
import styles from './default-button.module.scss';
import { IDefaultButtonProps } from './default-button.interface';

export const DefaultButton: React.FC<IDefaultButtonProps> = ({
  buttonText = 'Нет текста',
  color = 'white',
  disabled = false,
  className,
  onClick,
  ...props
}) => {
  const colorClassMap = {
    white: styles.white,
    green: styles.green,
    red: styles.red,
    blue: styles.blue,
    orange: styles.orange,
    purple: styles.purple,
    gray: styles.gray,
  };

  const buttonClass = `${styles.button} ${colorClassMap[color] || ''} ${className || ''}`;

  return (
    <button
      className={buttonClass}
      onClick={onClick}
      disabled={disabled}
      {...props}
    >
      {buttonText}
    </button>
  );
};
